export const WR_PAGINATION_SIZE = 25;
